import type { Job } from '@mairistem/composants';
import { request } from '@mairistem/tools';

const exportEmprunt = (identifiantExercice: number) =>
	request.get<unknown, Job>(
		`/api/finances/emprunt/export?identifiantExercice=${identifiantExercice}`,
	);

export default exportEmprunt;
